import React from 'react';
import moment from 'moment';
import {Row, Text, View} from '@unthinkable/react-core-components';
import {Icon} from '../../../components/icon';
import images from '../../../assets/images';

import {getVariant} from '../../../utils/commonMethod';
import {
  EncounterTimeLineStyle,
  TaskTitle,
} from './style/EncounterTimeLine.style';
import checkAuthorization from 'src/services/accessService';
import {useAuth} from 'src/modules/auth/hooks/useAuth';
import {action, entity} from 'src/constant/authorization';
import {useNavigate} from 'react-router-dom';
import buttonType from 'src/constant/buttonType';
import Config from 'src/Config';
import {TaskUserHaveAccess} from 'src/modules/tasks/TaskFilter';
import {Button} from 'src/components/button';
import {PatientClass} from '../constants/PatientConstants';

const PatientClassIcons = {
  Inpatient: {
    selected: 'BuildingsSelected',
    unselected: 'buildingDark',
  },
  Outpatient: {
    selected: 'HomeSelected',
    unselected: 'homeOutline',
  },
  Emergency: {
    selected: 'ambulanceSelected',
    unselected: 'ambulance',
  },
};

export const EncounterTimeline = ({
  encounters = [],
  selectedEncounter,
  handleEncounterClick,
}) => {
  const {user} = useAuth();
  const navigate = useNavigate();

  const taskUserHaveAccess = TaskUserHaveAccess({user});

  const showCreateButton =
    encounters?.length > 0 &&
    encounters[0]?.dischargeDate &&
    checkAuthorization(user, entity.encounter, action.create);

  return (
    <View style={EncounterTimeLineStyle.container}>
      <Row style={EncounterTimeLineStyle.headerContainer}>
        <Text style={EncounterTimeLineStyle.heading}>Encounter Timeline</Text>
        {showCreateButton && (
          <Button
            onPress={() => navigate('create-new-encounter')}
            icon={images.addIcon}
            iconPosition="right"
            buttonType={buttonType.linkButtonWithBorder}
          />
        )}
      </Row>

      <View style={EncounterTimeLineStyle.timeLineContainer}>
        {encounters.map((encounter, index) => (
          <EncounterItem
            key={index}
            encounter={encounter}
            isSelected={
              encounter?._id?.toString() === selectedEncounter?._id?.toString()
            }
            onClick={() => handleEncounterClick(encounter)}
            taskUserHaveAccess={taskUserHaveAccess}
          />
        ))}
      </View>
    </View>
  );
};

const EncounterItem = ({
  encounter,
  isSelected,
  onClick,
  taskUserHaveAccess,
}) => {
  const iconKey = encounter?.patientClass || PatientClass.Outpatient;
  const iconSrc =
    images[
      isSelected
        ? PatientClassIcons[iconKey]?.selected
        : PatientClassIcons[iconKey]?.unselected
    ];

  const filteredTasks = encounter?.taskInfo?.filter(task =>
    taskUserHaveAccess.includes(task?.type),
  );

  return (
    <View
      style={EncounterTimeLineStyle.EncounterItemContainer}
      onClick={onClick}>
      <Row style={EncounterTimeLineStyle.EncounterItemStyle}>
        <Icon src={iconSrc} />
        <Text
          style={
            isSelected
              ? EncounterTimeLineStyle.textSelected
              : EncounterTimeLineStyle.text
          }>
          {encounter?.admissionDate
            ? moment.utc(encounter.admissionDate).format(Config.dateFormat)
            : '---'}
        </Text>
        <Text
          style={{
            ...(isSelected
              ? EncounterTimeLineStyle.textSelected
              : EncounterTimeLineStyle.text),
            fontSize: '12px',
          }}>
          {encounter.status}
        </Text>
      </Row>

      {isSelected &&
        filteredTasks?.map((task, index) => {
          const variant = getVariant(task, encounter);
          return (
            <TaskTitle key={index} variant={variant}>
              {task.type}
            </TaskTitle>
          );
        })}
    </View>
  );
};
